import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import ClientesCCAll from './Components/ClientesCCAll';
import { Toaster } from 'react-hot-toast';

export default function ClientesCC() {

    return (
        <MainContent
            component={<ClientesCCAll />}
            titulo='Clientes con Autorización Inmediata'
            tableMaxWidth={true}
            noBackground={true}
        >
        </MainContent>

    );

};